import MarketingHeader from "@/components/MarketingHeader";
import MarketingFooter from "@/components/MarketingFooter";
import { CLINIC } from "@/lib/brand";

const doctorImg = "https://images.pexels.com/photos/7108327/pexels-photo-7108327.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function About() {
  return (
    <div>
      <MarketingHeader />
      <section className="max-w-6xl mx-auto px-5 md:px-10 py-16 md:py-24 grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5">
          <div className="aspect-[4/5] rounded-3xl overflow-hidden">
            <img src={doctorImg} alt={CLINIC.doctor} className="w-full h-full object-cover" />
          </div>
        </div>
        <div className="lg:col-span-7 fade-up">
          <p className="text-xs font-semibold tracking-[0.2em] uppercase text-[color:var(--muted)] mb-3">About</p>
          <h1 className="font-heading text-4xl md:text-6xl font-light tracking-tight mb-6">{CLINIC.doctor}</h1>
          <p className="text-sm font-medium text-[color:var(--secondary)] italic mb-6">"{CLINIC.tagline}"</p>
          <p className="text-[color:var(--muted)] text-base leading-relaxed mb-5">
            {CLINIC.doctor.split(" ")[1]} is the founding classical homoeopath at {CLINIC.name} with
            over 12 years of practice. She trained at one of India's leading homoeopathic colleges
            (BHMS) and completed her MD in Homoeopathic Materia Medica.
          </p>
          <p className="text-[color:var(--muted)] text-base leading-relaxed mb-5">
            Her practice is rooted in the principles of individualisation, single remedy and minimum dose.
            She specialises in chronic conditions — migraine, PCOS, skin disorders, paediatric care, and
            mental wellness.
          </p>
          <div className="mt-8 grid sm:grid-cols-3 gap-4">
            {[
              { k: "BHMS", v: "Bachelor of Homoeopathic Medicine" },
              { k: "MD (Hom)", v: "Materia Medica" },
              { k: "12+ yrs", v: "Clinical practice" },
            ].map((x) => (
              <div key={x.k} className="border border-[color:var(--border)] rounded-2xl p-5 bg-white">
                <p className="font-heading text-2xl text-[color:var(--primary)] font-light">{x.k}</p>
                <p className="text-xs text-[color:var(--muted)] mt-1">{x.v}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <MarketingFooter />
    </div>
  );
}
